import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="offcanvas"
// Manages offcanvas panels - supports both side panels and bottom sheets
export default class extends Controller {
  static targets = ["panel", "backdrop"]
  static values = {
    direction: { type: String, default: "left" } // "left", "right", "bottom"
  }

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  toggle() {
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (!this.hasPanelTarget) return

    // Show backdrop
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden")
      // Trigger reflow for transition
      this.backdropTarget.offsetHeight
      this.backdropTarget.classList.add("opacity-100")
      this.backdropTarget.classList.remove("opacity-0")
    }

    // Show panel based on direction
    if (this.directionValue === "bottom") {
      this.panelTarget.classList.remove("translate-y-full")
      this.panelTarget.classList.add("translate-y-0")
    } else if (this.directionValue === "right") {
      this.panelTarget.classList.remove("translate-x-full", "invisible")
      this.panelTarget.classList.add("translate-x-0")
    } else {
      this.panelTarget.classList.remove("-translate-x-full", "invisible")
      this.panelTarget.classList.add("translate-x-0")
    }

    // Prevent body scroll
    document.body.classList.add("overflow-hidden")

    // Add escape listener
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  close() {
    if (!this.hasPanelTarget) return

    // Hide backdrop
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("opacity-100")
      this.backdropTarget.classList.add("opacity-0")
      setTimeout(() => {
        this.backdropTarget.classList.add("hidden")
      }, 300)
    }

    // Hide panel based on direction
    if (this.directionValue === "bottom") {
      this.panelTarget.classList.add("translate-y-full")
      this.panelTarget.classList.remove("translate-y-0")
    } else if (this.directionValue === "right") {
      this.panelTarget.classList.add("translate-x-full", "invisible")
      this.panelTarget.classList.remove("translate-x-0")
    } else {
      this.panelTarget.classList.add("-translate-x-full", "invisible")
      this.panelTarget.classList.remove("translate-x-0")
    }

    // Re-enable body scroll
    document.body.classList.remove("overflow-hidden")

    // Remove escape listener
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  isOpen() {
    if (!this.hasPanelTarget) return false

    if (this.directionValue === "bottom") {
      return !this.panelTarget.classList.contains("translate-y-full")
    }
    return !this.panelTarget.classList.contains("invisible") &&
           !this.panelTarget.classList.contains("-translate-x-full") &&
           !this.panelTarget.classList.contains("translate-x-full")
  }
}
